import React, { useEffect, useState } from "react";

// Icons
import closeIcon from "../../../../../assets/icons/close.svg";
import yellowTemplateIcon from "../../../../../assets/icons/templates_icons/yellow-note-text.svg";

// Custom Components and Hooks
import RequestDropdown, {
  CLEAR_SELECTION_TEXT,
} from "../../../Dropdown/RequestDropdown";
import SplitFileUploadButton from "../../../buttons/SplitFileUploadButton/SplitFileUploadButton";
import {
  ADD_ENTIRE_REQUIRED_DOCS,
  ADD_REQUIRED_DOCUMENT,
  REMOVE_REQUIRED_DOCUMENT,
  UPDATE_CURRENT_SELECT_TEMPLATE,
  UPDATE_REQUIRED_DOCS_FROM_TEMPLATE,
  UPDATE_REQUIRED_DOCUMENT,
  getEmptyRequiredDocuments,
} from "../hooks/useRequestMutationForm";

// Apollo Client
import { useQuery } from "@apollo/client";

// GraphQL Queries
import {
  GET_ALL_DOCUMENT_REQUEST_TEMPLATES,
  formatTemplateResponse,
} from "../../../LeftSection/LeftSection";

// External Utilities
import { uploadClient } from "../../../../..";
import { deepCopy } from "../../../../../helper";
import { sort } from "fast-sort";

function TemplateSection({ onChange, state = {}, isEdit = false }) {
  const { data: rawTemplateResponse } = useQuery(
    GET_ALL_DOCUMENT_REQUEST_TEMPLATES,
    {
      client: uploadClient,
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  );

  const templateData = formatTemplateResponse(
    rawTemplateResponse?.documentrequesttemplates ?? []
  );

  // Handler
  const handleTemplateChange = (selectedValue) => {
    if (selectedValue === CLEAR_SELECTION_TEXT) {
      onChange(UPDATE_CURRENT_SELECT_TEMPLATE, {
        id: "",
        title: "",
      });
      const emptyRequiredDocuments = getEmptyRequiredDocuments();
      onChange(ADD_ENTIRE_REQUIRED_DOCS, [emptyRequiredDocuments]);
      onChange(
        UPDATE_REQUIRED_DOCS_FROM_TEMPLATE,
        deepCopy([emptyRequiredDocuments])
      );
      return;
    }
    const selectedTemplate = templateData.find(
      (template) => template.templateTitle === selectedValue
    );
    if (selectedTemplate) {
      const { templateId, templateTitle, requiredDocuments } = selectedTemplate;
      onChange(UPDATE_CURRENT_SELECT_TEMPLATE, {
        id: templateId,
        title: templateTitle,
      });
      onChange(ADD_ENTIRE_REQUIRED_DOCS, requiredDocuments);
      onChange(UPDATE_REQUIRED_DOCS_FROM_TEMPLATE, deepCopy(requiredDocuments));
    }
  };

  const [_forUpdate, setForceUpdate] = useState(null);

  const handleAddAnother = async () => {
    const emptyRequiredDocuments = { ...getEmptyRequiredDocuments() };
    onChange(ADD_REQUIRED_DOCUMENT, emptyRequiredDocuments);
    await delay(1);
    setForceUpdate(emptyRequiredDocuments?.documentId);
  };

  const scrollToAddNewButton = async () => {
    await delay(500);
    const addNewButton = document.getElementById("addAnotherBtnId");
    if (addNewButton) {
      addNewButton.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  };

  useEffect(() => {
    if (_forUpdate) {
      const inputCard = document.getElementById(_forUpdate);
      console.log(inputCard);
      if (inputCard) {
        inputCard.scrollIntoView({ behavior: "instant", block: "end" });
        scrollToAddNewButton();
      }
    }
  }, [_forUpdate]);
  return (
    <section className="request-mutation-modal-body-second-section">
      <div>
        <div className="my-5">
          <label>
            <span>Template </span>
            {Boolean(state?.isTemplateModified) && (
              <span className="font-italic text-color-020617">
                {"( Modified )"}
              </span>
            )}
          </label>
          <RequestDropdown
            placeholder="Choose Template"
            value={state.currentSelectTemplate.title}
            options={[
              ...sort(templateData)
                .asc((template) => template?.templateTitle?.toLowerCase())
                .map((template) => template.templateTitle),
              CLEAR_SELECTION_TEXT,
            ]}
            disabled={isEdit}
            onChange={handleTemplateChange}
          />
        </div>

        <div className="template-list-header">
          <img
            src={yellowTemplateIcon}
            width={"40px"}
            height={"40px"}
            alt="mailing"
          />
          <div>Requested Documents </div>
        </div>
        <div className="template-list-subheader mb-5">
          {"Use this area to indicate the required documents."}
        </div>
      </div>

      <div className="required-docs-form-container mb-5">
        <div className="required-docs-form-inputs">
          {Array.isArray(state.requiredDocs) &&
            state.requiredDocs.map((requiredDocument) => {
              return (
                <RequiredDocumentCard
                  key={requiredDocument.documentId}
                  requiredDocument={requiredDocument}
                  onChange={onChange}
                />
              );
            })}
        </div>
        <button
          id="addAnotherBtnId"
          className="light-primary-button mt-5"
          onClick={handleAddAnother}
        >
          Add Another
        </button>
      </div>
    </section>
  );
}

export default TemplateSection;

// Helper components

function RequiredDocumentCard({ requiredDocument, onChange }) {
  return (
    <div className="required-docs-card" id={requiredDocument.documentId}>
      <label htmlFor="templateTitle" className="template-drawer-form-label">
        Document
      </label>
      <div className="docs-name-input-container">
        <input
          type="text"
          placeholder="Enter Document Name"
          maxLength="50"
          id="templateTitle"
          className="min-height-49"
          value={requiredDocument.documentName}
          onChange={(e) =>
            onChange(UPDATE_REQUIRED_DOCUMENT, {
              documentId: requiredDocument.documentId,
              documentName: e.target.value,
            })
          }
        />

        <img
          className="close"
          src={closeIcon}
          alt="closeIcon"
          onClick={() =>
            onChange(REMOVE_REQUIRED_DOCUMENT, requiredDocument.documentId)
          }
          width={"20px"}
          height={"20px"}
        />
      </div>
      <SplitFileUploadButton
        fileName={requiredDocument.documentFileName}
        onChange={(documentFile) => {
          const documentFileName =
            documentFile !== null ? documentFile.name : "";
          onChange(UPDATE_REQUIRED_DOCUMENT, {
            documentId: requiredDocument.documentId,
            documentFileName,
            documentFile,
          });
        }}
        isFileUploadDisabled={requiredDocument.documentFile === -1}
      />
    </div>
  );
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
